import axios from "axios";
import { API_URL } from "@/config";
import downloadFile from "@/utils/downloadFile";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, { filters, pageNumber, perPage }) {
      let q = {
        ...filters,
        page: pageNumber,
      };

      if (perPage) {
        q.perPage = perPage;
      }

      const res = await axios.get(`${API_URL}/messages`, { params: q });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, formData) {
      const res = await axios.post(`${API_URL}/messages`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });

      if (res.status !== 201 || !res.data || res.data.status !== true) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async createMany(_, formData) {
      const res = await axios.post(`${API_URL}/messages/many`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });

      if (res.status !== 201 || !res.data || res.data.status !== true) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async read(_, messagesReadData) {
      const res = await axios.post(`${API_URL}/messages/read`, messagesReadData);

      if (res.status !== 200 || !res.data || res.data.status !== true) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async download(_, { messageId, attachmentId }) {
      const response = await axios({
        url: `${API_URL}/messages/${messageId}/attachments/${attachmentId}/download`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      downloadFile(response);
    },
  },
};

export default store;
